export enum UserStatus {
  PRE_ACCOUNT = 'Пре-аккаунт',
  ACCOUNT = 'Аккаунт',
  DECLINED = 'Отклонен',
  APPROVAL = 'Проверка',
  IDENTIFIED = 'Идентифицирован',
  CLIENT = 'Клиент',
  QUALIFIED = 'Квалифицированный',
  EMPLOYEE = 'Работник',
  ON_SIGN = 'Подписание документов',
}
